"use client"
import {Bar} from "../../interfaces/Bar";
import {Box, Button, IconButton, Link} from "@chakra-ui/react";
import NextLink from "next/link";
import {useTranslations} from "next-intl";
import {MdDirections} from "react-icons/md";

export default function BarLink(
    {bar, onlyIcon = false}: {bar: Bar, onlyIcon?: boolean}
) {
    const link = `https://www.google.com/maps/search/?api=1&query=${bar.address}&query_place_id=${bar.id}`
    const t = useTranslations("Home")
    return (
        <Box data-nosnippet>
            <Link rel="nofollow" isExternal as={NextLink} color='teal.500' href={link}>
                {onlyIcon ? (
                    <IconButton variant="outline" borderRadius="full" icon={<MdDirections fontSize="1.5rem"/> } aria-label="get directions"/>
                ) : (
                    <Button size="lg" rightIcon={<MdDirections fontSize="1.5rem"/>} variant="solid">{t("openMap")}</Button>
                )}
            </Link>
        </Box>
    )
}